


































import Vue from 'vue';
import { AttributoList } from '../../types';
import * as attributoApi from '../../services/attributo-api';
import validationRules from '../mixin/validation-rules';
import attributoEdit from '@/components/commands/AttributoEdit.vue';

export default Vue.extend({
    data() {
        return {
            items: [] as AttributoList[],
            selectedValue: null as any,
            disabled: false as boolean,
            editComponent: attributoEdit,
            dialog: false as boolean,
        };
    },
    props: {
        multiple: { default: false },
        label: { required: true, type: String },
        tipo: { default: null },
        itemText: { default: 'valore' },
        itemValue: { default: 'id' },
        clearable: { default: false },
        setDefault: { default: false },
        value: {},
        parent: { default: null },
        cascade: { default: false },
        required: { default: false },
        canAdd: { default: false },
    },
    computed: {
        validationRules(): any[] {
            return this.required
                ? [validationRules.getRequiredRule(this.label)]
                : [];
        },
    },
    methods: {
        onChange(e: any) {
            this.$emit('input', e);
            this.$emit(
                'itemselected',
                this.items.filter(
                    (item) =>
                        (this.multiple &&
                            (e as any[]).filter((p) => p.id === item.id)
                                .length > 0) ||
                        (!this.multiple && item.id === e)
                )[0]
            );
        },
        async loadItems() {
            this.items = await attributoApi.getByTipo(this.tipo, this.parent);
            if (
                this.setDefault &&
                this.items.length > 0 &&
                !this.selectedValue
            ) {
                this.selectedValue = this.multiple
                    ? [this.items[0].id]
                    : this.items[0].id;
                this.onChange(this.selectedValue);
            }
            if (
                (!this.multiple &&
                    this.items.filter((item) => item.id === this.selectedValue)
                        .length === 0) ||
                (this.multiple &&
                    this.selectedValue &&
                    this.selectedValue.length > 0 &&
                    (this.selectedValue as any[]).filter(
                        (selected) =>
                            this.items.filter((item) => item.id === selected)
                                .length > 0
                    ).length === 0)
            ) {
                this.selectedValue = null;
                this.onChange(this.selectedValue);
            }
            this.disabled = false;
        },
        dialogClose() {
            this.dialog = false;
        },
        onSave(e: AttributoList) {
            this.items.push(e);
            if (!this.multiple) {
                this.selectedValue = e.id;
            } else {
                if (!this.selectedValue) this.selectedValue = [];
                this.selectedValue.push(e.id);
            }
            this.onChange(this.selectedValue);
        },
        getComponentProps() {
            return {
                tipo: this.tipo,
            };
        },
        clearSelection() {
            this.selectedValue = this.selectedValue == 0 ? null : 0;
        },
    },
    async created() {
        if (!this.cascade) {
            await this.loadItems();
        } else {
            this.disabled = true;
        }
    },
    watch: {
        value: {
            handler: function (val) {
                if (val || !this.setDefault) {
                    this.selectedValue = val;
                }
                this.onChange(this.selectedValue);
            },
            immediate: true,
        },
        parent: {
            handler: async function (val) {
                if (this.cascade && val) {
                    await this.loadItems();
                }
            },
            immediate: true,
        },
    },
});
